import React from "react";
import { Toggle } from "@/modern/components/ui/toggle";
import { ScanEye, Scan } from "lucide-react";

interface EditorWarRoomToggleProps {
  pressed: boolean;
  onPressedChange: (pressed: boolean) => void;
}

export const EditorWarRoomToggle = ({ pressed, onPressedChange }: EditorWarRoomToggleProps) => {
  return (
    <Toggle
      variant="outline"
      size="sm"
      className="shrink-0 whitespace-nowrap"
      pressed={pressed}
      onPressedChange={onPressedChange}
      aria-label="Toggle War Room sizing"
    >
      {pressed ? <Scan className="size-4" /> : <ScanEye className="size-4" />}
      {pressed ? "Standard" : "War Room"}
    </Toggle>
  );
};
